import * as React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    appSection: {
        margin: '3rem 0',
        '& h3, h2, h1': {
            marginBottom: '3rem',
            fontSize: '1.3em',
            '@media screen and (min-width: 640px)': {
                fontSize: '1.4em',
            },
            '@media screen and (min-width: 768px)': {
                fontSize: '1.5em',
            },
            '@media screen and (min-width: 1024px)': {
                fontSize: '1.7em',
            },
            '@media screen and (min-width: 1520px)': {
                fontSize: '1.8em',
            }
        },
    }
});

interface AppSectionProps {
    children: React.ReactElement[] | React.ReactElement;
    header?: string;
    headerType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const AppSection: React.FC<AppSectionProps> = ({ children, header = null, headerType='h2' }: AppSectionProps) => {
    const classes = useStyles();
    const headline = React.createElement(headerType, {}, header);

    return (
        <div className={classes.appSection}>
            {header && headline}
            {children}
        </div>
    );
};

export default React.memo(AppSection);
